import PropTypes from 'prop-types'
import { PageType } from './defaultTypes'

export const footerPropTypes = {
  linkLists: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      elements: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          title: PropTypes.string,
          shortcut: PropTypes.string,
          url: PropTypes.string,
        })
      ),
    })
  ),
}

export const headerPropTypes = {
  mainMenu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  fixedLinks: PropTypes.shape({
    easyLanguage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    signLanguage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    start: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
}

export const metaPropTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.array,
  aokTitle: PropTypes.string,
  aokDescription: PropTypes.string,
  mindbreezeNoIndex: PropTypes.bool,
  releaseDate: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
}

export const pageHeaderPropTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
    subtitle: PropTypes.string,
  }),
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  abstract: PropTypes.string,
  image: PropTypes.shape({
    alt: PropTypes.string,
    copyright: PropTypes.string,
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        breakpoint: PropTypes.number,
      })
    ),
  }),
}

export const teaserListPagePropTypes = {
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
}

export const privacyPropTypes = {
  socialMedia: PropTypes.shape({
    headline: PropTypes.string,
    text: PropTypes.string,
  }),
  video: PropTypes.shape({
    text: PropTypes.string,
  }),
  instagram: PropTypes.shape({
    text: PropTypes.string,
  }),
  tiktok: PropTypes.shape({
    text: PropTypes.string,
  }),
  googlemaps: PropTypes.shape({
    text: PropTypes.string,
  }),
  localisationCookie: PropTypes.shape({
    text: PropTypes.string,
  }),
}

export const settingsPropTypes = {
  limit: PropTypes.number,
  count: PropTypes.number,
  tags: PropTypes.string,
  type: PropTypes.oneOf([PageType.CATEGORY, PageType.TAG, PageType.TOPIC]),
}

export const clientListPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    shortcut: PropTypes.string,
    url: PropTypes.string,
  })
)
